import {
  checkLoginApi,
  getUserBasicApi,
  logoutApi,
  queryBiddogGrayReleaseApi
} from '@/api/user'
import { toLogin } from '@/utils/common'
import { queryValueAddedServiceCategoryRightsApi } from '@/api/value-added'
import {
  valueAddedCategoryCodeDict,
  valueAddedProductCodeDict
} from '@/dictionary/value-added'

const state = {
  // 是否登录， false未登录， true登录
  isLogin: false,
  // 登录的用户角色, 企业员工-purchase、专家-expert
  loginIdentity: [],
  // 用户信息
  userInfo: {},
  // 会员信息
  vipInfo: {},
  // 灰度信息
  biddogGray: [],
  // 是否显示画像菜单
  isPortraitBtnShow: true,

  // 在线客服链接
  wxLink: 'https://work.weixin.qq.com/kfid/kfc96a68f350ac60a82'
}

const mutations = {
  SET_IS_LOGIN: (state, isLogin) => {
    state.isLogin = isLogin
  },
  SET_USER_IDENTITY: (state, identity) => {
    state.loginIdentity = identity
  },
  SET_USER_INFO: (state, userInfo) => {
    state.userInfo = userInfo
  },
  SET_VIP_INFO: (state, vipInfo) => {
    state.vipInfo = vipInfo
  },
  SET_BIDDOG_GRAY: (state, biddogGray) => {
    state.biddogGray = biddogGray
  },
  SET_IS_PORTRAIT_BTN_SHOW: (state, isPortraitBtnShow) => {
    state.isPortraitBtnShow = isPortraitBtnShow
  }
}

const actions = {
  /**
   * 检查登录状态
   * @returns {Promise<unknown>}
   */
  checkLogin({ commit }) {
    return new Promise((resolve, reject) => {
      checkLoginApi()
        .then((res) => {
          const identity = []
          if (res.data?.purchase) {
            identity.push('purchase')
          }
          if (res.data?.expert) {
            identity.push('expert')
          }
          commit('SET_IS_LOGIN', true)
          commit('SET_USER_IDENTITY', identity || [])
          resolve(res)
        })
        .catch((err) => {
          commit('SET_IS_LOGIN', false)
          commit('SET_VIP_INFO', {})
          reject(err)
        })
    })
  },

  /**
   * 退出登录
   * @returns {Promise<unknown>}
   */
  logout({ commit, rootState }) {
    return new Promise((resolve, reject) => {
      logoutApi()
        .then((res) => {
          commit('SET_IS_LOGIN', false)
          commit('SET_USER_IDENTITY', [])
          commit('SET_BASIC_INFO', {})
          commit('SET_SECURITY_INFO', {})
          commit('SET_VIP_INFO', {})
          commit('cacheView/DEL_ALL_HISTORY_LENGTH', {}, { root: true })
        })
        .catch((err) => {
          reject(err)
        })
        .finally(() => {
          toLogin()
        })
    })
  },

  /**
   * 获取用户基本信息
   */
  getUserBasicInfo({ commit }) {
    return new Promise((resolve, reject) => {
      getUserBasicApi()
        .then((res) => {
          const userInfo = {
            nickname: res.data.userInfo.nickname,
            ...res.data
          }
          commit('SET_USER_INFO', userInfo)
          resolve(res)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  /**
   * 获取用户会员权益信息
   */
  getUserVipInfo({ commit }) {
    return new Promise((resolve, reject) => {
      queryValueAddedServiceCategoryRightsApi(
        valueAddedCategoryCodeDict.VIP.value
      )
        .then((res) => {
          // 有会员权益的情况下，取第一个会员权益
          const vipInfo = (res.data || []).find((item) => !item.isExpire) || {}
          if (vipInfo.rightsId) {
            const vipEntry = valueAddedProductCodeDict.translate(
              vipInfo.productInfo?.productCode
            )
            vipInfo.vipLevel = vipEntry.alias
            vipInfo.servicePhone = vipEntry.servicePhone
          }

          commit('SET_VIP_INFO', vipInfo)
          resolve(res)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  /**
   * 获取灰度信息
   */
  /* eslint-disable */
  getBiddogGray({ commit, state }) {
    return new Promise((resolve, reject) => {
      queryBiddogGrayReleaseApi()
        .then((res) => {
          // 有会员权益的情况下，取第一个会员权益
          const data = res.data || []
          // if (data.length) {
          //   data.map((item) => {
          //     // 判断当前用户是否展示画像按钮
          //     if (item.feature == 'portrait' && item.enable) {
          //       if (item.openScope.length && item.openScope.includes(state.vipInfo.userId)) {
          //         commit('SET_IS_PORTRAIT_BTN_SHOW', true)
          //       } else {
          //         commit('SET_IS_PORTRAIT_BTN_SHOW', false)
          //       }
          //     }
          //     if (item.feature == 'portrait' && !item.enable) {
          //       commit('SET_IS_PORTRAIT_BTN_SHOW', true)
          //     }
          //   })
          // }
          commit('SET_BIDDOG_GRAY', data)
          resolve(res)
        })
        .catch((err) => {
          reject(err)
        })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
